export const ACTION_NAME = {
  SIGNUP_USER: 'SIGNUP_USER',
  SIGNIN_USER: 'SIGNIN_USER',
  SIGNOUT_USER: 'SIGNOUT_USER',
  KEEP_AUTH_USER: 'KEEP_AUTH_USER',
  READ_PROJECTS: 'READ_PROJECTS',
  CREATE_PROJECT: 'CREATE_PROJECT',
  UPDATE_PROJECT: 'UPDATE_PROJECT',
  DELETE_PROJECT: 'DELETE_PROJECT',
  CREATE_LABEL: 'CREATE_LABEL',
  UPDATE_LABEL: 'UPDATE_LABEL',
  DELETE_LABEL: 'DELETE_LABEL',
  READ_LABELS: 'READ_LABELS',
  CREATE_TASK: 'CREATE_TASKS',
  READ_TASKS: 'READ_TASKS',
  UPDATE_TASK: 'UPDATE_TASK',
  UPDATE_TASK_STATUS: 'UPDATE_TASK_STATUS',
  DELETE_TASK: 'DELETE_TASK',
  RESCHEDULE_TASK: 'RESCHEDULE_TASK',
  READ_TASKS_SUMMARY: 'READ_TASKS_SUMMARY',
  READ_STARTER_DATA: 'READ_STARTER_DATA',
  CREATE_POST: 'CREATE_POST',
  READ_POSTS: 'READ_POSTS',
  READ_POST: 'READ_POST',
  COMMENT_ON_POST: 'COMMENT_ON_POST',
  LIKE_A_POST: 'LIKE_A_POST',
  READ_ONE_POST: 'READ_ONE_POST',
  UPDATE_POST: 'UPDATE_POST',
  DELETE_POST: 'DELETE_POST',
};
